/**
 * Minimize Shopify cookie banner after Accept/Decline; subtle FAB reopens preferences.
 */
(function () {
  const MINIMIZED_CLASS = 'huong-cookie-banner-minimized';
  const FAB_SELECTOR = '[data-huong-cookie-fab]';
  const BANNER_ID = 'shopify-pc__banner';
  const ACCEPT_ID = 'shopify-pc__banner__btn-accept';
  const DECLINE_ID = 'shopify-pc__banner__btn-decline';
  const PREFS_OVERLAY_ID = 'shopify-pc__prefs__overlay';
  let prefsWatcherStarted = false;

  function getPrivacyBannerApi() {
    if (typeof privacyBanner !== 'undefined') return privacyBanner;
    if (typeof window.privacyBanner !== 'undefined') return window.privacyBanner;
    return null;
  }

  function getFab() {
    return document.querySelector(FAB_SELECTOR);
  }

  function showFab() {
    const fab = getFab();
    if (fab) fab.hidden = false;
  }

  function hideFab() {
    const fab = getFab();
    if (fab) fab.hidden = true;
  }

  function minimizeBanner() {
    document.body.classList.add(MINIMIZED_CLASS);
    showFab();
  }

  function setFabBusy(isBusy) {
    const fab = getFab();
    if (!fab) return;
    fab.classList.toggle('is-active', isBusy);
    fab.dataset.opening = isBusy ? 'true' : 'false';
  }

  function openCookiePreferences() {
    const api = getPrivacyBannerApi();
    if (api && typeof api.showPreferences === 'function') {
      return api.showPreferences().then(function () {
        watchPrefsClose();
      });
    }
    document.body.classList.remove(MINIMIZED_CLASS);
    return Promise.resolve();
  }

  function attachBannerButtonListeners() {
    const accept = document.getElementById(ACCEPT_ID);
    const decline = document.getElementById(DECLINE_ID);
    [accept, decline].forEach(function (btn) {
      if (!btn || btn.dataset.huongCookieBound) return;
      btn.dataset.huongCookieBound = 'true';
      btn.addEventListener('click', minimizeBanner);
    });
  }

  function watchBannerMount() {
    if (document.getElementById(BANNER_ID)) {
      attachBannerButtonListeners();
      return;
    }
    const observer = new MutationObserver(function () {
      if (document.getElementById(BANNER_ID)) {
        attachBannerButtonListeners();
        observer.disconnect();
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () {
      observer.disconnect();
    }, 30000);
  }

  function watchPrefsClose() {
    if (prefsWatcherStarted) return;
    prefsWatcherStarted = true;

    document.addEventListener(
      'click',
      function (event) {
        const target = event.target;
        if (!(target instanceof Element)) return;
        if (
          target.closest('#shopify-pc__prefs__header-close') ||
          target.closest('#shopify-pc__prefs__header-save') ||
          target.closest('#shopify-pc__prefs__header-accept') ||
          target.closest('#shopify-pc__prefs__header-decline')
        ) {
          window.requestAnimationFrame(minimizeBanner);
        }
      },
      true
    );

    const observeOverlay = function () {
      const overlay = document.getElementById(PREFS_OVERLAY_ID);
      if (!overlay) return false;
      const observer = new MutationObserver(function () {
        const hidden =
          overlay.hidden ||
          overlay.getAttribute('aria-hidden') === 'true' ||
          overlay.style.display === 'none' ||
          !overlay.offsetParent;
        if (hidden) minimizeBanner();
      });
      observer.observe(overlay, {
        attributes: true,
        attributeFilter: ['hidden', 'aria-hidden', 'style', 'class'],
      });
      return true;
    };

    if (!observeOverlay()) {
      const mountObserver = new MutationObserver(function () {
        if (observeOverlay()) mountObserver.disconnect();
      });
      mountObserver.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  function onFabActivate(event) {
    event.preventDefault();
    const fab = getFab();
    if (!fab || fab.hidden || fab.dataset.opening === 'true') return;

    setFabBusy(true);
    openCookiePreferences()
      .catch(function () {
        /* noop */
      })
      .finally(function () {
        window.setTimeout(function () {
          setFabBusy(false);
        }, 120);
      });
  }

  function initAfterConsentApi() {
    document.addEventListener('visitorConsentCollected', minimizeBanner);
    watchBannerMount();

    if (window.Shopify?.customerPrivacy?.shouldShowBanner?.() === false) {
      minimizeBanner();
    } else {
      hideFab();
    }
  }

  function boot() {
    const fab = getFab();
    if (!fab) return;

    fab.addEventListener('pointerdown', onFabActivate);

    if (window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function () {
          initAfterConsentApi();
        }
      );
    } else {
      initAfterConsentApi();
    }

    watchBannerMount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
